<script>
import { mapActions } from "vuex";
export default {
  methods: {
    ...mapActions("signUp", ["setAccountableType"])
  }
};
</script>

<template>
  <base-flex direction="column" align="stretch">
    <a class="professional-register" href="https://donamaid.com/seja-diarista-com-a-donamaid/">
      <base-button size="large" outlined>sou diarista e quero fazer limpeza</base-button>
    </a>
    <hr />
    <base-button size="large" @click="setAccountableType('physical')">quero limpeza na minha casa</base-button>
    <base-button size="large" @click="setAccountableType('legal')">quero limpeza na minha empresa</base-button>
  </base-flex>
</template>

<style lang="scss" scoped>
hr {
  width: 35%;
  opacity: 0.4;
}

.professional-register {
  margin: 0 auto;
}

button {
  margin: 7px 5px !important;

  @media (min-width: 768px) {
    margin: 7px 20px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SignUp/Main.vue